import React from 'react'
import { Button } from 'components/Form'
import { HiOutlineRefresh } from 'react-icons/hi'

/**
 * Form action buttons component
 * @param {Object} props - Component props
 */
const FormActions = ({ id, submitting, syncing, selectedCompany, isValid, handleRefreshData, handleDiscard }) => {
    return (
        <div className="flex items-center justify-between gap-4 mt-6">
            <Button
                type="button"
                className="h-10 px-6 text-white bg-blue-600 hover:bg-blue-700 flex items-center gap-2"
                onClick={handleRefreshData}
                disabled={syncing || !selectedCompany}
            >
                <HiOutlineRefresh className={syncing ? 'animate-spin' : ''} />
                {syncing ? 'Refreshing Data...' : 'Refresh Data'}
            </Button>
            <div className="flex items-center gap-4">
                <Button
                    type="button"
                    className="h-10 px-6 text-gray-600 border border-gray-300 hover:bg-gray-50"
                    onClick={handleDiscard}
                    disabled={submitting}
                >
                    Cancel
                </Button>
                <Button
                    type="submit"
                    className="flex items-center justify-center px-6 py-2 text-white transition border rounded-lg cursor-pointer hover:bg-opacity-90 border-primary bg-primary dark:border-secondary dark:bg-secondary"
                    disabled={submitting || !isValid}
                >
                    {submitting ? (id ? 'Updating...' : 'Creating...') : id ? 'Update Invoice' : 'Create Invoice'}
                </Button>
            </div>
        </div>
    )
}

export default FormActions
